/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiOutlinedInputStyle = (): Components<Theme>["MuiOutlinedInput"] => ({
  styleOverrides: {
    root: {
      "& input:-webkit-autofill": {
        /* TODO: Check if theme var can be used */
        WebkitBoxShadow: "0 0 0 100px #E8F0FE inset",
        WebkitTextFillColor: "#000",
        transition: "background-color 5000s ease-in-out 0s",
      },
    },
  },
});
